(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  /**
   * Accordion section — exclusive open behavior only.
   * Base expand/collapse uses native <details> (no JS required).
   * Event-delegated once; safe with multiple accordion sections.
   */
  (function () {
    if (window.__brightcodeAccordionInit) return;
    window.__brightcodeAccordionInit = true;

    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS') return;
        if (!d.classList || !d.classList.contains('brightcode-acc__item')) return;
        if (!d.open) return;
        var section = d.closest('[data-brightcode-acc]');
        if (!section) return;
        if (section.getAttribute('data-allow-multiple') === 'true') return;
        var siblings = section.querySelectorAll('details.brightcode-acc__item');
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== d && siblings[i].open) {
            siblings[i].open = false;
          }
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brightcode-magic-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Magic Carousel only — layout + viewport video gate.
   * Does not patch assets/slideshow.js (update-safe; other carousels untouched).
   */
  const MAGIC_MOBILE_MQ = '(max-width: 749px)';

  function magicIsMobile() {
    return window.matchMedia(MAGIC_MOBILE_MQ).matches;
  }

  function magicIsTouchDevice() {
    try {
      if (window.matchMedia('(pointer: coarse)').matches) return true;
    } catch (e) {
      // ignore
    }
    return (navigator.maxTouchPoints || 0) > 1;
  }

  /**
   * Video source picker — width-based first. For landscape phones (width
   * 750-950) fall back to the short viewport edge, but ONLY on touch
   * devices — laptops with a short browser window (no toolbar/taskbar
   * space, or zoomed out) also have a small innerHeight and must NOT be
   * treated as mobile just because of that.
   */
  function magicIsMobileVideo() {
    try {
      if (window.matchMedia(MAGIC_MOBILE_MQ).matches) return true;
    } catch (e) {
      // ignore
    }
    if (magicIsTouchDevice()) {
      const shortEdge = Math.min(window.innerWidth || 0, window.innerHeight || 0);
      const longEdge = Math.max(window.innerWidth || 0, window.innerHeight || 0);
      if (shortEdge > 0 && shortEdge <= 500 && longEdge <= 950) return true;
    }
    return false;
  }

  function magicReduceMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /** Explicit Save-Data only — do not treat flaky effectiveType (2g) as autoplay-block */
  function magicSaveData() {
    try {
      const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return !!(c && c.saveData);
    } catch (e) {
      return false;
    }
  }

  /** Pixel-based visibility — tall stages make intersectionRatio unreliable */
  function magicEntryVisible(entry) {
    if (!entry || !entry.isIntersecting) return false;
    const h = (entry.intersectionRect && entry.intersectionRect.height) || 0;
    const w = (entry.intersectionRect && entry.intersectionRect.width) || 0;
    if (w <= 0 || h <= 0) return false;
    const vh = window.innerHeight || document.documentElement.clientHeight || 0;
    return h >= Math.min(80, Math.max(48, vh * 0.08));
  }

  function magicRectVisible(rect) {
    if (!rect || !(rect.height > 0) || !(rect.width > 0)) return false;
    const vh = window.innerHeight || document.documentElement.clientHeight || 0;
    const visibleH = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    return visibleH >= Math.min(80, Math.max(48, vh * 0.08));
  }

  function magicGetCards(scroller) {
    return scroller ? [...scroller.querySelectorAll(':scope > .card')] : [];
  }

  function magicGetRealCards(scroller) {
    return scroller
      ? [...scroller.querySelectorAll(':scope > .card:not([data-magic-clone])')]
      : [];
  }

  function magicIsLoop(section) {
    return section?.dataset?.magicLoop === 'true';
  }

  function magicDisableCloneMedia(root) {
    root.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (e) {
        /* ignore */
      }
      video.removeAttribute('autoplay');
      video.removeAttribute('src');
      video.removeAttribute('data-src');
      try {
        video.load();
      } catch (e2) {
        /* ignore */
      }
    });
  }

  /**
   * Seamless loop: clone last before first + first after last so peeks stay filled
   * and last→first scrolls as an adjacent move (no slideshow.js reorder flash).
   */
  function magicEnsureLoopClones(section) {
    const slideshow = section.querySelector('slideshow-component');
    const scroller = slideshow?.querySelector('slideshow-slides');
    if (!scroller) return;

    slideshow?.removeAttribute('infinite');
    scroller.querySelectorAll(':scope > .card[data-magic-clone]').forEach((el) => el.remove());

    const reals = magicGetRealCards(scroller);
    reals.forEach((card, i) => {
      card.dataset.magicRealIndex = String(i);
      card.removeAttribute('data-magic-clone');
    });

    if (!magicIsLoop(section) || reals.length < 2) return;

    /* Keep infinite attr so theme won't disable end arrows; next/prev still use our smooth clone loop */
    slideshow?.setAttribute('infinite', '');

    const first = reals[0];
    const last = reals[reals.length - 1];

    const before = last.cloneNode(true);
    before.dataset.magicClone = 'before';
    before.dataset.magicRealIndex = last.dataset.magicRealIndex;
    before.setAttribute('aria-hidden', 'true');
    magicDisableCloneMedia(before);

    const after = first.cloneNode(true);
    after.dataset.magicClone = 'after';
    after.dataset.magicRealIndex = first.dataset.magicRealIndex;
    after.setAttribute('aria-hidden', 'true');
    magicDisableCloneMedia(after);

    scroller.insertBefore(before, first);
    scroller.appendChild(after);
  }

  function magicCardScrollTarget(scroller, card) {
    if (!scroller || !card) return 0;
    if (magicIsMobile()) {
      const pad =
        parseFloat(getComputedStyle(scroller).paddingInlineStart) || magicScrollPaddingStart(scroller) || 0;
      return Math.max(0, card.offsetLeft - pad);
    }
    const scrollerRect = scroller.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const delta =
      cardRect.left + cardRect.width / 2 - (scrollerRect.left + scroller.clientWidth / 2);
    return scroller.scrollLeft + delta;
  }

  function magicScrollToCard(scroller, card, instant) {
    if (!scroller || !card) return;
    const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const target = magicCardScrollTarget(scroller, card);
    const behavior = instant || magicReduceMotion() ? 'instant' : 'smooth';
    scroller.scrollTo({ left: Math.min(Math.max(0, target), maxScroll), behavior });
  }

  function magicNearestCardIndex(scroller, cards) {
    if (!scroller || !cards.length) return 0;
    const mobile = magicIsMobile();
    const pad = magicScrollPaddingStart(scroller);
    const ref = mobile
      ? scroller.scrollLeft + pad
      : scroller.scrollLeft + scroller.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    cards.forEach((card, i) => {
      const point = mobile ? card.offsetLeft : card.offsetLeft + card.offsetWidth / 2;
      const dist = Math.abs(point - ref);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });
    return best;
  }

  function magicUnlockLoopArrows(section) {
    if (!magicIsLoop(section)) return;
    const slideshow = section.querySelector('slideshow-component');
    slideshow?.setAttribute('infinite', '');
    section.querySelectorAll('.carousel-content .slideshow-control').forEach((btn) => {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
    });
  }

  function magicMarkActiveCard(section, activeCard) {
    const scroller = section.querySelector('slideshow-slides');
    const cards = magicGetCards(scroller);
    cards.forEach((el) => {
      el.setAttribute('aria-hidden', el === activeCard ? 'false' : 'true');
    });
    const slideshow = section.querySelector('slideshow-component');
    const reals = magicGetRealCards(scroller);
    let realIndex = reals.indexOf(activeCard);
    if (realIndex < 0 && activeCard?.dataset?.magicRealIndex != null) {
      realIndex = Number(activeCard.dataset.magicRealIndex);
    }
    if (slideshow && realIndex >= 0) {
      try {
        slideshow.current = realIndex;
      } catch (e) {
        /* ignore */
      }
    }
    magicUnlockLoopArrows(section);
    if (typeof section._magicSyncVideos === 'function') section._magicSyncVideos();
    if (typeof section._magicSyncDocker === 'function') {
      section._magicSyncDocker(realIndex >= 0 ? realIndex : 0);
    }
    magicUpdateMediaHeight(section);
  }

  /** Landed on a clone → instant jump to matching real card (invisible teleport). */
  function magicNormalizeLoopPosition(section) {
    if (!magicIsLoop(section)) return;
    const scroller = section.querySelector('slideshow-slides');
    const cards = magicGetCards(scroller);
    if (!cards.length) return;
    const card = cards[magicNearestCardIndex(scroller, cards)];
    if (!card?.hasAttribute('data-magic-clone')) {
      magicMarkActiveCard(section, card);
      return;
    }
    const realIndex = Number(card.dataset.magicRealIndex);
    const real = magicGetRealCards(scroller).find((c) => Number(c.dataset.magicRealIndex) === realIndex);
    if (!real) return;
    magicScrollToCard(scroller, real, true);
    magicMarkActiveCard(section, real);
  }

  function magicLoopStep(section, direction) {
    const scroller = section.querySelector('slideshow-slides');
    const cards = magicGetCards(scroller);
    if (cards.length < 2) return;
    const current = magicNearestCardIndex(scroller, cards);
    const next = Math.max(0, Math.min(cards.length - 1, current + direction));
    if (next === current) return;
    const card = cards[next];
    magicScrollToCard(scroller, card, false);
    magicMarkActiveCard(section, card);

    let settled;
    const finish = () => {
      clearTimeout(settled);
      magicNormalizeLoopPosition(section);
    };
    const onScrollEnd = () => {
      scroller.removeEventListener('scrollend', onScrollEnd);
      finish();
    };
    if ('onscrollend' in window) {
      scroller.addEventListener('scrollend', onScrollEnd, { once: true });
    }
    settled = setTimeout(finish, magicReduceMotion() ? 32 : 450);
  }

  function magicBindLoop(section) {
    if (section.dataset.magicLoopBound === '1') return;
    section.dataset.magicLoopBound = '1';

    magicEnsureLoopClones(section);
    section._magicEnsureLoopClones = () => magicEnsureLoopClones(section);

    const slideshow = section.querySelector('slideshow-component');
    if (!slideshow) return;

    const scroller = slideshow.querySelector('slideshow-slides');

    if (magicIsLoop(section)) {
      slideshow.setAttribute('infinite', '');
      slideshow.next = (event) => {
        event?.preventDefault?.();
        magicLoopStep(section, 1);
      };
      slideshow.previous = (event) => {
        event?.preventDefault?.();
        magicLoopStep(section, -1);
      };
      magicUnlockLoopArrows(section);
      /* slideshow.current setter may re-disable arrows — keep them unlocked */
      const unlock = () => magicUnlockLoopArrows(section);
      section.addEventListener('slideshow:select', unlock);
      scroller?.addEventListener('scroll', unlock, { passive: true });
    }

    let scrollTimer;
    scroller?.addEventListener(
      'scroll',
      () => {
        if (!magicIsLoop(section)) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => magicNormalizeLoopPosition(section), 140);
      },
      { passive: true }
    );
  }

  function magicScrollPaddingStart(scroller) {
    const raw = getComputedStyle(scroller).scrollPaddingInlineStart || '0';
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }

  /**
   * Desktop: resolve slide/peek to px.
   * Loop mode: clones fill edge peeks — no blank end padding.
   */
  function magicIsSingle(section) {
    return section?.dataset?.magicSingle === 'true';
  }

  function magicSyncPeekLayout(section) {
    const content = section.querySelector('.carousel-content');
    const scroller = section.querySelector('slideshow-slides');
    if (!content || !scroller) return;

    const single = magicIsSingle(section);
    const mobile = magicIsMobile();
    const W = content.clientWidth;
    if (W < 2) return;

    const mode = (content.dataset.carouselPagination || 'hint').toLowerCase();
    const desktopHint = parseFloat(content.dataset.hintPercentage || '18');
    const mobileHint = parseFloat(
      content.dataset.hintPercentageMobile || content.dataset.hintPercentage || '12',
    );
    let hintPct = mobile ? mobileHint : desktopHint;
    if (!Number.isFinite(hintPct)) hintPct = mobile ? 12 : 18;
    hintPct = Math.min(35, Math.max(5, hintPct));

    let peek = 0;
    let slideW = W;

    if (mode === 'hint') {
      peek = (W * hintPct) / 100;
      slideW = Math.max(0, W - 2 * peek);
      content.style.setProperty('--magic-hint-pct', String(hintPct));
      content.style.setProperty('--magic-hint-pct-mobile', String(mobileHint));
    } else {
      content.style.setProperty('--magic-hint-pct', '0');
      content.style.setProperty('--magic-hint-pct-mobile', '0');
    }

    content.style.setProperty('--magic-slide-width', `${slideW}px`);
    content.style.setProperty('--magic-peek', `${peek}px`);

    if (magicIsLoop(section) && !single && !mobile && mode === 'hint') {
      scroller.style.paddingInline = '0px';
      scroller.style.scrollPaddingInline = `${peek}px`;
    } else {
      scroller.style.paddingInline = `${peek}px`;
      scroller.style.scrollPaddingInline = `${peek}px`;
    }
  }

  function magicGoToSlide(section, indexOverride) {
    const slideshow = section.querySelector('slideshow-component');
    const scroller = slideshow?.querySelector('slideshow-slides');
    if (!slideshow || !scroller) return;

    magicSyncPeekLayout(section);
    if (typeof section._magicEnsureLoopClones === 'function') {
      section._magicEnsureLoopClones();
    } else if (magicIsLoop(section)) {
      magicEnsureLoopClones(section);
    }

    const reals = magicGetRealCards(scroller);
    if (!reals.length) return;

    const mobile = magicIsMobile();
    const single = magicIsSingle(section);
    let index =
      indexOverride != null
        ? Number(indexOverride)
        : single || mobile
          ? 0
          : Number(section.dataset.magicInitialSlide || 1);

    if (Number.isNaN(index) || index < 0) index = single || mobile ? 0 : 1;
    if (index > reals.length - 1) index = reals.length - 1;

    magicScrollToCard(scroller, reals[index], true);
    magicMarkActiveCard(section, reals[index]);
  }

  /** Measure active card media height so arrows center on image/video only. */
  function magicUpdateMediaHeight(section) {
    const slideshow = section.querySelector('slideshow-component');
    const scroller = slideshow?.querySelector('slideshow-slides');
    const reals = magicGetRealCards(scroller);
    if (!reals.length) return;

    let active =
      section.querySelector('.card[aria-hidden="false"]:not([data-magic-clone])') ||
      reals[slideshow?.current ?? 0] ||
      reals[0];
    if (active?.hasAttribute('data-magic-clone')) {
      const ri = Number(active.dataset.magicRealIndex);
      active = reals.find((c) => Number(c.dataset.magicRealIndex) === ri) || reals[0];
    }
    const media =
      active?.querySelector('.card__media-wrapper') ||
      active?.querySelector('.card__content') ||
      active;
    const h = media ? Math.round(media.getBoundingClientRect().height) : 0;
    const content = section.querySelector('.carousel-content');
    if (h > 0) {
      section.style.setProperty('--magic-media-height', `${h}px`);
      content?.style.setProperty('--magic-media-height', `${h}px`);
    }
    // Keep docker fallback math in sync with the active card's aspect setting
    const ratioEl = active?.querySelector('.card__media-wrapper, .card__content') || active;
    let ratio = 1.777778;
    if (ratioEl) {
      const cs = getComputedStyle(ratioEl);
      const key = magicIsMobile() ? '--card-ratio-mobile-numeric' : '--card-ratio-numeric';
      const raw = (cs.getPropertyValue(key) || cs.getPropertyValue('--card-ratio-numeric') || '').trim();
      const n = parseFloat(raw);
      if (Number.isFinite(n) && n > 0.05) ratio = n;
    }
    section.style.setProperty('--magic-active-ratio', String(ratio));
    content?.style.setProperty('--magic-active-ratio', String(ratio));
  }

  /**
   * Fixed docker — CSS pins it to the active viewport slot.
   * Slide changes only update which dot is active (position never moves).
   */
  function magicBindDocker(section) {
    if (section.dataset.magicDockerBound === '1') return;
    section.dataset.magicDockerBound = '1';

    if (section.dataset.magicShowDocker === 'false') {
      section.querySelectorAll('[data-magic-docker]').forEach((el) => el.remove());
      section._magicSyncDocker = function () {};
      return;
    }

    /* Host inherits --magic-slide-width / --magic-peek from .carousel-content */
    const host =
      section.querySelector('.carousel-content') ||
      section.querySelector('.magic-carousel__stage') ||
      section;
    let docker = section.querySelector('[data-magic-docker]');
    if (!docker) {
      docker = document.createElement('div');
      docker.className = 'magic-carousel__docker';
      docker.setAttribute('data-magic-docker', '');
      docker.setAttribute('role', 'tablist');
      docker.setAttribute('aria-label', 'Slide pagination');
      host.appendChild(docker);
    } else if (docker.parentElement !== host) {
      host.appendChild(docker);
    }

    /* Strip legacy per-card / moving dockers */
    section.querySelectorAll('[data-magic-docker]').forEach((el) => {
      if (el !== docker) el.remove();
    });
    docker.style.transform = '';
    docker.style.width = '';
    docker.removeAttribute('data-magic-placed');

    let lastIndex = -1;
    let scrollTimer;

    function rebuildDots(cardCount) {
      if (docker.childElementCount === cardCount && cardCount >= 2) return;
      docker.replaceChildren();
      lastIndex = -1;
      if (cardCount < 2) {
        docker.hidden = true;
        docker.setAttribute('data-magic-docker-shell', '');
        return;
      }
      const frag = document.createDocumentFragment();
      for (let i = 0; i < cardCount; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'magic-carousel__docker-dot';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.dataset.magicDockerIndex = String(i);
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          magicGoToSlide(section, i);
        });
        frag.appendChild(btn);
      }
      docker.appendChild(frag);
      docker.hidden = false;
      docker.removeAttribute('data-magic-docker-shell');
    }

    function markDots(index) {
      const slideshow = section.querySelector('slideshow-component');
      const scroller = slideshow?.querySelector('slideshow-slides');
      const reals = magicGetRealCards(scroller);
      if (!reals.length) return;

      if (docker.childElementCount !== reals.length) {
        rebuildDots(reals.length);
      }
      if (reals.length < 2) {
        docker.hidden = true;
        return;
      }

      let i =
        index == null || Number.isNaN(Number(index))
          ? (() => {
              const all = magicGetCards(scroller);
              const nearest = all[magicNearestCardIndex(scroller, all)];
              if (!nearest) return 0;
              if (nearest.dataset.magicRealIndex != null) return Number(nearest.dataset.magicRealIndex);
              return Math.max(0, reals.indexOf(nearest));
            })()
          : Number(index);
      i = Math.max(0, Math.min(reals.length - 1, i));
      if (i === lastIndex) return;
      lastIndex = i;

      docker.hidden = false;
      docker.removeAttribute('data-magic-docker-shell');
      docker.querySelectorAll('.magic-carousel__docker-dot').forEach((dot) => {
        const on = Number(dot.dataset.magicDockerIndex) === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    section._magicSyncDocker = markDots;

    const slideshow = section.querySelector('slideshow-component');
    const scroller = slideshow?.querySelector('slideshow-slides');
    rebuildDots(magicGetRealCards(scroller).length);
    magicUpdateMediaHeight(section);
    markDots(slideshow?.current ?? 0);

    scroller?.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          markDots(null);
          magicUpdateMediaHeight(section);
        }, 80);
      },
      { passive: true }
    );
  }

  /**
   * Magic video controller — poster-first for fast loads:
   * - No src / no buffer until the VIDEO itself is on screen AND active
   * - Pause + poster when off-screen or inactive
   * - Keep src after first play so resume does not jump
   */
  function magicBindVideos(section) {
    if (section.dataset.magicVideoBound === '1') return;
    section.dataset.magicVideoBound = '1';

    let scrollTimer;
    const videoInView = new WeakMap();

    const videos = () => [...section.querySelectorAll('.card:not([data-magic-clone]) video')];

    function getActiveCard() {
      const slideshow = section.querySelector('slideshow-component');
      const scroller = slideshow?.querySelector('slideshow-slides');
      const cards = magicGetCards(scroller);
      if (!cards.length || !scroller) return null;

      const idx = magicNearestCardIndex(scroller, cards);
      let best = cards[idx];
      if (best?.hasAttribute('data-magic-clone')) {
        const ri = Number(best.dataset.magicRealIndex);
        best =
          magicGetRealCards(scroller).find((c) => Number(c.dataset.magicRealIndex) === ri) || best;
      }
      return best || magicGetRealCards(scroller)[0] || null;
    }

    function saveTime(video) {
      if (!video) return;
      const t = video.currentTime;
      if (!Number.isFinite(t) || t < 0.05) return;
      video.dataset.magicTime = String(t);
    }

    function showPoster(video) {
      video.dataset.magicPoster = '1';
    }

    function hidePoster(video) {
      delete video.dataset.magicPoster;
      video.removeAttribute('data-magic-poster');
    }

    function absolutizeSrc(url) {
      if (!url) return '';
      if (url.indexOf('//') === 0) return 'https:' + url;
      return url;
    }

    function preferredPoster(video) {
      const slot = video.dataset.bcVideoSlot;
      const mobilePoster = video.dataset.mobilePoster || '';
      const desktopPoster = video.dataset.desktopPoster || video.getAttribute('poster') || '';
      if (slot === 'mobile') return absolutizeSrc(mobilePoster || desktopPoster);
      if (slot === 'desktop') return absolutizeSrc(desktopPoster || mobilePoster);
      const raw = magicIsMobileVideo()
        ? mobilePoster || desktopPoster
        : desktopPoster || mobilePoster;
      return absolutizeSrc(raw);
    }

    function preferredSrc(video) {
      const slot = video.dataset.bcVideoSlot;
      if (slot === 'mobile') {
        return absolutizeSrc(video.dataset.mobileSrc || video.dataset.desktopSrc || '');
      }
      if (slot === 'desktop') {
        return absolutizeSrc(video.dataset.desktopSrc || video.dataset.mobileSrc || '');
      }
      let raw = magicIsMobileVideo()
        ? video.dataset.mobileSrc || video.dataset.desktopSrc
        : video.dataset.desktopSrc || video.dataset.mobileSrc;
      if (raw) return absolutizeSrc(raw);
      const source = video.querySelector('source[data-video-source], source[src]');
      if (source) {
        raw = source.dataset.videoSource || source.getAttribute('src') || '';
        if (raw) return absolutizeSrc(raw);
      }
      return absolutizeSrc(video.getAttribute('src') || video.currentSrc || '');
    }

    function isSlotActive(video) {
      const slot = video.dataset.bcVideoSlot;
      if (!slot) return true;
      const mobile = magicIsMobileVideo();
      const split = video.closest('[data-bc-video-split]');
      if (split && mobile) {
        const mobileEl = split.querySelector('[data-bc-video-slot="mobile"]');
        const mobileSrc = mobileEl ? preferredSrc(mobileEl) : '';
        if (!mobileSrc) return slot === 'desktop';
      }
      return mobile ? slot === 'mobile' : slot === 'desktop';
    }

    function syncVideoSlots() {
      const mobile = magicIsMobileVideo();
      section.querySelectorAll('[data-bc-video-split]').forEach((bg) => {
        const mobileEl = bg.querySelector('[data-bc-video-slot="mobile"]');
        const mobileSrc = mobileEl ? preferredSrc(mobileEl) : '';
        const useDesktopFallback = mobile && !mobileSrc;
        bg.classList.toggle('is-mobile-fallback-desktop', useDesktopFallback);
        bg.classList.toggle('is-mobile-video', mobile && !useDesktopFallback);
        bg.classList.toggle('is-desktop-video', !mobile || useDesktopFallback);
      });
    }

    /** True only when a meaningful portion of THIS video is on screen */
    function magicVideoVisible(entryOrRect, boundingHeight) {
      let h = 0;
      let w = 0;
      let targetH = boundingHeight || 0;
      if (entryOrRect && typeof entryOrRect.isIntersecting === 'boolean') {
        if (!entryOrRect.isIntersecting) return false;
        h = (entryOrRect.intersectionRect && entryOrRect.intersectionRect.height) || 0;
        w = (entryOrRect.intersectionRect && entryOrRect.intersectionRect.width) || 0;
        targetH = (entryOrRect.boundingClientRect && entryOrRect.boundingClientRect.height) || targetH;
      } else if (entryOrRect) {
        const rect = entryOrRect;
        if (!(rect.height > 0) || !(rect.width > 0)) return false;
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        h = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        w = Math.min(rect.right, window.innerWidth || 0) - Math.max(rect.left, 0);
        targetH = rect.height;
      }
      if (w <= 0 || h <= 0) return false;
      const need = Math.min(Math.max(targetH * 0.35, 120), Math.max(120, targetH * 0.85));
      return h >= need;
    }

    function isVideoOnScreen(video) {
      if (videoInView.has(video)) return videoInView.get(video) === true;
      return magicVideoVisible(video.getBoundingClientRect());
    }

    /** Attach src only when about to play — never preload off-screen */
    function attachSrc(video) {
      const next = preferredSrc(video);
      if (!next) return false;
      const poster = preferredPoster(video);
      if (poster && video.getAttribute('poster') !== poster) {
        video.setAttribute('poster', poster);
      }
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      video.querySelectorAll('source[data-video-source]').forEach((source) => {
        const url = source.dataset.videoSource;
        if (url && !source.getAttribute('src')) source.setAttribute('src', url);
      });

      const applied = video.dataset.appliedSrc || '';
      const hasSrc = !!(video.getAttribute('src') || video.currentSrc);
      if (applied === next && hasSrc) return true;

      video.dataset.appliedSrc = next;
      video.dataset.currentSrc = next;
      video.preload = 'none';
      video.setAttribute('preload', 'none');
      while (video.firstChild) video.removeChild(video.firstChild);
      video.src = next;
      try {
        video.load();
      } catch (e) {
        /* ignore */
      }
      return true;
    }

    function pauseVideo(video) {
      if (!(video instanceof HTMLVideoElement)) return;
      saveTime(video);
      if (!video.paused) {
        try {
          video.pause();
        } catch (e) {
          /* ignore */
        }
      }
    }

    function playVideo(video) {
      if (!(video instanceof HTMLVideoElement)) return;
      if (magicReduceMotion() || magicSaveData()) {
        showPoster(video);
        return;
      }
      if (!isVideoOnScreen(video)) {
        showPoster(video);
        return;
      }
      if (!attachSrc(video)) return;

      if (!video.paused && !video.ended) {
        hidePoster(video);
        return;
      }

      const saved = parseFloat(video.dataset.magicTime || '');
      if (Number.isFinite(saved) && saved >= 0.05 && video.readyState >= 1) {
        const cur = video.currentTime || 0;
        if (cur < 0.2) {
          try {
            const dur = video.duration;
            video.currentTime =
              Number.isFinite(dur) && dur > 0 ? Math.min(saved, Math.max(0, dur - 0.25)) : saved;
          } catch (e) {
            /* ignore */
          }
        }
      }

      const p = video.play();
      if (p && p.catch) {
        p.catch(() => {
          const retry = () => {
            if (!isVideoOnScreen(video)) return;
            if (Number.isFinite(saved) && saved >= 0.05 && video.readyState >= 1) {
              try {
                if ((video.currentTime || 0) < 0.2) video.currentTime = saved;
              } catch (e) {
                /* ignore */
              }
            }
            const p2 = video.play();
            if (p2 && p2.catch) p2.catch(() => {});
          };
          video.addEventListener('loadeddata', retry, { once: true });
          setTimeout(retry, 300);
        });
      }
      video.addEventListener('playing', () => hidePoster(video), { once: true });
      if (!video.paused) hidePoster(video);
    }

    function canPlayVideo(video, activeCard, single) {
      if (magicReduceMotion() || magicSaveData()) return false;
      if (!isSlotActive(video)) return false;
      if (!isVideoOnScreen(video)) return false;
      if (single) return true;
      return !!(activeCard && activeCard.contains(video));
    }

    function syncVideos() {
      syncVideoSlots();
      const single = magicIsSingle(section);
      const activeCard = getActiveCard();

      videos().forEach((video) => {
        if (canPlayVideo(video, activeCard, single)) {
          playVideo(video);
        } else {
          pauseVideo(video);
          showPoster(video);
        }
      });
    }

    section._magicSyncVideos = syncVideos;

    videos().forEach((video) => {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('preload', 'none');
      // Ensure off-screen videos never start with a network src
      if (video.getAttribute('src') && !video.dataset.appliedSrc) {
        const pending = preferredSrc(video);
        if (pending) {
          video.dataset.desktopSrc = video.dataset.desktopSrc || pending;
          video.dataset.mobileSrc = video.dataset.mobileSrc || pending;
        }
        video.removeAttribute('src');
        try {
          video.load();
        } catch (e) {
          /* ignore */
        }
      }
      videoInView.set(video, false);
      showPoster(video);
      pauseVideo(video);
    });

    let videoObserver = null;
    try {
      if (typeof IntersectionObserver !== 'undefined') {
        videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              videoInView.set(entry.target, magicVideoVisible(entry));
            });
            syncVideos();
          },
          { threshold: [0, 0.1, 0.25, 0.35, 0.5, 0.75, 1], rootMargin: '0px' }
        );
      }
    } catch (e) {
      videoObserver = null;
    }

    videos().forEach((video) => {
      if (videoObserver) videoObserver.observe(video);
      else videoInView.set(video, magicVideoVisible(video.getBoundingClientRect()));
    });

    const scroller = section.querySelector('slideshow-slides');
    scroller?.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncVideos, 80);
      },
      { passive: true }
    );

    section.addEventListener(
      'play',
      (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement) || !section.contains(video)) return;
        const activeCard = getActiveCard();
        const single = magicIsSingle(section);
        if (!canPlayVideo(video, activeCard, single)) {
          pauseVideo(video);
          showPoster(video);
          return;
        }
        hidePoster(video);
      },
      true
    );

    // Do not play on boot — wait for IntersectionObserver (poster-first)
    syncVideos();
    setTimeout(syncVideos, 400);
  }

  function initMagicCarousels() {
    document.querySelectorAll('[data-magic-carousel]').forEach((section) => {
      if (section.dataset.magicBound === '1') return;
      section.dataset.magicBound = '1';

      magicSyncPeekLayout(section);
      magicBindLoop(section);
      magicBindVideos(section);
      magicBindDocker(section);

      const runInitial = () => {
        magicSyncPeekLayout(section);
        if (typeof section._magicEnsureLoopClones === 'function') {
          section._magicEnsureLoopClones();
        }
        // Mobile must always open on slide 0 flush-left; desktop uses setting / center peek
        magicGoToSlide(section, magicIsMobile() ? 0 : undefined);
        magicUpdateMediaHeight(section);
      };

      requestAnimationFrame(() => requestAnimationFrame(runInitial));
      setTimeout(runInitial, 50);
      setTimeout(runInitial, 150);
      setTimeout(runInitial, 400);
      setTimeout(runInitial, 900);

      // slideshow.js may select(initial) on a later frame — re-center slide 0 on mobile
      let guardUntil = Date.now() + 1600;
      const guard = setInterval(() => {
        if (Date.now() > guardUntil) {
          clearInterval(guard);
          return;
        }
        if (!magicIsMobile()) return;
        const slideshow = section.querySelector('slideshow-component');
        const scroller = slideshow?.querySelector('slideshow-slides');
        const cards = magicGetCards(scroller);
        const first = cards[0];
        if (!slideshow || !scroller || !first) return;
        // Centered peek: card center should align with scroller center
        const scRect = scroller.getBoundingClientRect();
        const cRect = first.getBoundingClientRect();
        const scMid = scRect.left + scRect.width / 2;
        const cMid = cRect.left + cRect.width / 2;
        if (slideshow.current !== 0 || Math.abs(cMid - scMid) > 18) {
          magicGoToSlide(section, 0);
        }
      }, 120);

      let resizeTimer;
      let wasMobile = magicIsMobile();
      let wasMobileVideo = magicIsMobileVideo();
      const onViewportChange = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const nowMobile = magicIsMobile();
          const nowMobileVideo = magicIsMobileVideo();
          const slideshow = section.querySelector('slideshow-component');
          // Desktop↔mobile video metafield swap (incl. phone landscape)
          if (nowMobileVideo !== wasMobileVideo) {
            wasMobileVideo = nowMobileVideo;
            section.querySelectorAll('video[data-card-responsive-video]').forEach((video) => {
              delete video.dataset.appliedSrc;
              video.removeAttribute('data-applied-src');
            });
            if (typeof section._magicSyncVideos === 'function') section._magicSyncVideos();
          }
          // Crossing layout breakpoint: mobile always restarts at slide 0
          if (nowMobile !== wasMobile) {
            wasMobile = nowMobile;
            if (typeof section._magicEnsureLoopClones === 'function') {
              section._magicEnsureLoopClones();
            }
            magicGoToSlide(section, nowMobile ? 0 : undefined);
            return;
          }
          const current = slideshow ? slideshow.current : null;
          if (typeof section._magicEnsureLoopClones === 'function') {
            section._magicEnsureLoopClones();
          }
          magicGoToSlide(section, current != null ? current : undefined);
          magicUpdateMediaHeight(section);
        }, 100);
      };
      window.addEventListener('resize', onViewportChange, { passive: true });
      window.addEventListener('orientationchange', onViewportChange, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagicCarousels, { once: true });
  } else {
    initMagicCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target?.closest?.('.shopify-section')?.querySelector?.('[data-magic-carousel]') ||
      event.target?.querySelector?.('[data-magic-carousel]') ||
      (event.target?.hasAttribute?.('data-magic-carousel') ? event.target : null);
    if (!section) return;
    section.dataset.magicBound = '0';
    section.dataset.magicVideoBound = '0';
    section.dataset.magicDockerBound = '0';
    initMagicCarousels();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brightcode-parallax"] && !Shopify.designMode) return;
  try {
    
  /**
   * Brightcode Parallax — sticky stack polish + light media preload.
   * Cards pin via CSS sticky; JS scales/dims a card as the next one covers it.
   * Fabric desktop (≥990px) scrolls `.page-wrapper`, not window.
   */
  (function () {
    const MOBILE_MQ = '(max-width: 749px)';
    const REDUCE_MQ = '(prefers-reduced-motion: reduce)';
    const SQUEEZE_MQ = '(min-width: 990px)';
    const PAGE_WRAPPER = '.page-wrapper';

    function prefersReducedMotion() {
      return window.matchMedia(REDUCE_MQ).matches;
    }

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function isSqueezeLayout() {
      return window.matchMedia(SQUEEZE_MQ).matches;
    }

    function getScrollEventTarget() {
      if (isSqueezeLayout()) {
        return document.querySelector(PAGE_WRAPPER) || document;
      }
      return document;
    }

    function stackEffectsEnabled(section) {
      if (prefersReducedMotion()) return false;
      if (isMobile() && section.dataset.stackMobile !== 'true') return false;
      return true;
    }

    function resetCards(cards) {
      cards.forEach((card) => {
        card.style.transform = '';
        card.style.filter = '';
      });
    }

    function updateStack(cards, scalePct) {
      const maxShrink = Math.max(0, Math.min(20, scalePct)) / 100;

      cards.forEach((card, index) => {
        const next = cards[index + 1];
        if (!next) {
          card.style.transform = '';
          card.style.filter = '';
          return;
        }

        const stickyTop = parseFloat(getComputedStyle(card).top) || 0;
        const cardH = card.getBoundingClientRect().height || 1;
        const nextTop = next.getBoundingClientRect().top;
        // 0 = next still below; 1 = next fully covering (at sticky top)
        const progress = Math.min(1, Math.max(0, 1 - (nextTop - stickyTop) / cardH));
        const scale = 1 - progress * maxShrink;
        card.style.transform = 'scale(' + scale.toFixed(4) + ')';
        // Dim only on desktop — filter paint is costlier on mobile
        if (isMobile()) {
          card.style.filter = '';
        } else {
          const brightness = 1 - progress * 0.28;
          card.style.filter = 'brightness(' + brightness.toFixed(3) + ')';
        }
      });
    }

    function lqipFromUrl(url) {
      if (!url) return '';
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('width', '48');
        return u.href;
      } catch (e) {
        return '';
      }
    }

    function paintLqip(card) {
      const surface =
        card.querySelector('.background-image-container, .video-background, video-background-component, .card__media-wrapper');
      if (!surface || surface.dataset.bcLqip === '1') return;
      const img = card.querySelector('.card__media-wrapper img');
      const src = img && (img.currentSrc || img.src);
      const lqip = lqipFromUrl(src);
      surface.style.backgroundColor = '#2c2c2c';
      if (lqip) {
        surface.style.backgroundImage = 'url("' + lqip + '")';
        surface.style.backgroundSize = 'cover';
        surface.style.backgroundPosition = 'center';
      }
      surface.dataset.bcLqip = '1';
    }

    function preloadCard(card) {
      if (!card || card.dataset.bcMediaPreloaded === '1') return;
      card.dataset.bcMediaPreloaded = '1';
      paintLqip(card);
      card.querySelectorAll('.card__media-wrapper img').forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager';
        const src = img.currentSrc || img.src;
        if (!src) return;
        const pre = new Image();
        pre.decoding = 'async';
        pre.src = src;
      });
    }

    function bindMedia(section, cards) {
      if (section.dataset.parallaxMediaBound === '1') return;
      section.dataset.parallaxMediaBound = '1';

      // First two cards: LQIP + preload so sticky cover never flashes empty
      cards.slice(0, 2).forEach(preloadCard);
      cards.forEach(paintLqip);

      if (!('IntersectionObserver' in window)) {
        cards.forEach(preloadCard);
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            preloadCard(card);
            const idx = cards.indexOf(card);
            if (idx >= 0 && cards[idx + 1]) preloadCard(cards[idx + 1]);
          });
        },
        { root: null, rootMargin: '100% 0px 100% 0px', threshold: 0.01 }
      );
      cards.forEach((card) => io.observe(card));
    }

    function bindSection(section) {
      if (section.dataset.parallaxBound === '1') return;
      section.dataset.parallaxBound = '1';

      const cards = [...section.querySelectorAll('.brightcode-parallax__cards .card')];
      if (!cards.length) return;

      bindMedia(section, cards);

      let ticking = false;
      let scrollTarget = null;

      function requestTick() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          if (!stackEffectsEnabled(section)) {
            resetCards(cards);
            return;
          }
          const scalePct = Number(section.dataset.stackScale || 8);
          updateStack(cards, scalePct);
        });
      }

      function attachScroll() {
        if (scrollTarget) {
          scrollTarget.removeEventListener('scroll', requestTick);
        }
        scrollTarget = getScrollEventTarget();
        scrollTarget.addEventListener('scroll', requestTick, { passive: true });
      }

      attachScroll();
      window.addEventListener('resize', requestTick, { passive: true });

      const squeezeMq = window.matchMedia(SQUEEZE_MQ);
      const onSqueezeChange = () => {
        attachScroll();
        requestTick();
      };
      if (typeof squeezeMq.addEventListener === 'function') {
        squeezeMq.addEventListener('change', onSqueezeChange);
      } else if (typeof squeezeMq.addListener === 'function') {
        squeezeMq.addListener(onSqueezeChange);
      }

      requestTick();
    }

    function initAll() {
      document.querySelectorAll('[data-brightcode-parallax]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      const section =
        root?.querySelector?.('[data-brightcode-parallax]') ||
        (root?.hasAttribute?.('data-brightcode-parallax') ? root : null);
      if (!section) return;
      section.dataset.parallaxBound = '0';
      section.dataset.parallaxMediaBound = '0';
      bindSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
